import {
  ExternalTransaction,
  ExternalTransactionStatus,
} from '@helios/common-api'
import { composeFieldPath } from '@northfork/basics'
import { BulkExternalTransaction } from './bulk-external-transactions.model'

export type ExternalTransactionStatusKey =
  keyof typeof ExternalTransactionStatus

export const externalTransactionField = composeFieldPath(
  [] as BulkExternalTransaction[],
)

export interface ExternalTransactionSetValues {
  tranTypeCodes: string[]
  securityTypeCodes: string[]
  currencyCodes: string[]
  status: string[]
  dataSourceType: string[]
}

export type ExternalTransactionAvailableActions =
  | 'hold'
  | 'unhold'
  | 'ignore'
  | 'unignore'
  | 'delete'
  | 'match'
  | 'matchUsingExternal'
  | 'unmatch'

export interface CashEntryUpdatedCwanTransaction
  extends UpdatedCwanTransaction {
  postDate?: string
  amount?: number
}

export interface UpdatedCwanTransaction {
  category: TranCategory
}

export enum TranCategory {
  TRADE = 'TRADE',
  TRANSFER = 'TRANSFER',
  CASH_ENTRY = 'CASH_ENTRY',
  FX_TRADE = 'FX_TRADE',
  CURRENCY_FORWARD = 'CURRENCY_FORWARD',
  DIRECT_TRANSFER = 'DIRECT_TRANSFER',
  OTHER = 'OTHER',
}
